<template>
    <div class="uploaderWrapper">
        <div v-if="isShow" class="uploader">
            <label class="uploadBtn" for="fileLoad">
                <div class="loaderPic" :class="'pic_' + currentType"></div>
                <span class="btn">{{ btnContext[currentType] }}</span>
                <input type="file" class="uploadVideo" :accept="accepts[currentType]" multiple="multiple" id="fileLoad"
                       v-if="isAgreement" @change.self="onUploadFile($event)"/>
            </label>
            <div class="bottom">
                <div class="agreement">
                    <el-checkbox v-model="isAgreement"/>
                    我已同意<a href="http://www.g12e.org/notice/xuzhi.html" target="_blank">中小学教育联盟网用户上传规则</a>
                </div>
                <el-tooltip v-for="(item,index) in tooltip" :key="index" class="tooltipItem" effect="dark"
                            :content="item.hasChild ? item[currentType].content : item.content"
                            placement="bottom-start">
                    <span>{{ item.hasChild ? item[currentType].title : item.title }}</span>
                </el-tooltip>
            </div>
        </div>
        <div v-else class="content_progress">
            <div class="upload_progress_list" v-for="(item,index) in list[currentType]" :key="index">
                <i class="picType" :class="'pic_' + currentType"></i>
                <el-progress :percentage="100"/>
                <p class="upload_progress_list_filename">{{ item.oldName }}</p>
                <div class="handleBtn">
                    <router-link :to="'/creator/upload/edit?id='+ item.rscID">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
                            <i class="el-icon-edit"></i>
                        </el-tooltip>
                    </router-link>
                    <a href="javascript:void(0)" @click="onDeleteFile(item.rscID)">
                        <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                            <i class="el-icon-delete"></i>
                        </el-tooltip>
                    </a>
                </div>
            </div>

            <template v-for="item in listProgress[currentType]">
                <div v-if="item.isUploading" class="upload_progress_list" :key="item.tid">
                    <i class="picType" :class="'pic_' + currentType"></i>
                    <el-progress :percentage="item.percent"/>
                    <p class="upload_progress_list_filename">{{ item.filename }}</p>
                    <p class="upload_progress_list_loaded">已上传：{{ item.loaded }}M</p>
                    <p class="upload_progress_list_total">文件大小：{{ item.total }}M</p>
                    <p class="upload_progress_list_speed">上传速度：{{ item.speed }}/KB</p>
                </div>
            </template>


            <div class="add_upload">
                <input type="file" class="add_uploadBtn" :accept="accepts[currentType]" multiple="multiple"
                       @change.self="onUploadFile($event)"/>
                + {{ btnContext[currentType] }}
            </div>
        </div>
    </div>
</template>
<script>
  import { getDraftsInfoApi, deleteRscApi, uploadRscApi } from '@/api/creator';
  import { $Cookies } from '@/utils';
  import cosUpload from '@/mixins/cosUpload';

  export default {
    name: 'UploadReady',
    props: {
      type: {
        type: String,
        default: '2'
      }
    },
    data () {
      return {
        isAgreement: true,
        currentType: 'video',
        accepts: {
          video: '.flv,.wav,.wmv,.rm,.rmvb,.avi,. mpeg,.mpg,.asf,.3gp,.mp4,.vob',
          audio: '.mp3',
          doc: '.doc,.format,.to_pdf,.pdf,.txt,.doc,.docx,.xls,.xlsx,.ppt'
        },
        btnContext: {
          video: '视频上传',
          audio: '音频上传',
          doc: '文档上传'
        },
        tooltip: [
          {
            hasChild: false,
            title: '禁止发布的内容',
            content: '不得上传未经授权的他人作品，以及色 情、反动等违法视频、文档。'
          },
          {
            hasChild: true,
            video: {
              title: '视频格式',
              content: '目前我们支持的视频格式有：flv、wav、wmv、rm、rmvb、avi、 mpeg、mpg、asf、3gp、mp4、vob'
            },
            audio: {
              title: '音频格式',
              content: '目前我们支持的音频格式为： mp3'
            },
            doc: {
              title: '文档格式',
              content: '目前我们支持的文档格式有： doc、format、to_pdf、pdf、txt、doc、docx、xls、xlsx、 ppt'
            }
          },
          {
            hasChild: true,
            video: {
              title: '视频大小',
              content: '视频大小限制：1GB'
            },
            audio: {
              title: '音频大小',
              content: '音频大小限制：500M'
            },
            doc: {
              title: '文档大小',
              content: '文档大小限制：100M'
            }
          },
          {
            hasChild: false,
            title: '资源处理流程',
            content: '1. 上传：将资源上传至服务器。2. 审核：进入内容审核阶段。3. 发布：审核通过，资源正式发布'
          }
        ],
        limit: {
          video: {
            size: 1024 * 1024 * 1024,
            content: '视频文件大小超过1G，请重新上传！'
          },
          audio: {
            size: 1024 * 1024 * 500,
            content: '音频文件大小超过500M，请重新上传！'
          },
          doc: {
            size: 1024 * 1024 * 100,
            content: '文档文件大小超过100M，请重新上传！'
          }
        },
        list: {
          video: [],
          audio: [],
          doc: [],
        },
        listProgress: {
          video: {},
          audio: {},
          doc: {},
        },
        cos: '',
        isShow: false,
        isPause: false, // 是否暂停上传
      };
    },
    watch: {
      type: function (v) {
        v = Number(v);
        if (v === 4) {
          this.currentType = 'audio';
        } else if (v === 2) {
          this.currentType = 'video';
        } else if (v === 1) {
          this.currentType = 'doc';
        }
        this.getDraftsInfo();
      }
    },
    async mounted () {
      await this.getDraftsInfo();
    },
    methods: {
      async getDraftsInfo () {
        const uid = $Cookies.get('uid');
        const params = {
          userNo: uid,
          rscFileType: Number(this.type)
        };
        await getDraftsInfoApi(params).then(data => {
          if (data.success) {
            if (this.type === '2') {
              this.list.video = data.result.drafts;
            } else if (this.type === '4') {
              this.list.audio = data.result.drafts;
            } else if (this.type === '1') {
              this.list.doc = data.result.drafts;
            }
            this.swShow();
          } else {
            this.$message({
              type: 'error',
              message: data.errorMsg
            });
          }
        });
      },
      onDeleteFile (id) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const uid = $Cookies.get('uid');
          const params = {
            userNo: uid,
            id: id
          };
          deleteRscApi(params).then(data => {
            if (data.success) {
              this.$message.success('文件删除成功！');
              this.getDraftsInfo();
            } else {
              this.$message({
                type: 'error',
                message: data.errorMsg
              });
            }
          });

        }).catch(() => {
          return false;
        });
      },
      // 腾讯云取消上传任务
      onCancleTask (list, taskId, index) {
        if (!taskId) return;
        this.cos.cancelTask(taskId);
        list.splice(index, 1);
      },
      // 腾讯云暂停上传任务
      onPauseTask (item) {
        if (!item.taskId) return;
        this.isPause = !this.isPause;
        if (this.isPause) {
          this.cos.pauseTask(item.taskId);
        } else {
          this.cos.restartTask(item.taskId);
        }
      },
      swShow () {
        this.isShow = !this.list[ this.currentType ].length && Object.keys(this.listProgress[ this.currentType ]).length === 0;
      },
      isNaN (value) {
        return typeof value === 'number' && window.isNaN(value);
      },
      onUploadFile (event) {
        const me = this;
        const uid = $Cookies.get('uid');
        let _type = this.type === '2' || this.type === '4' ? 1 : 2;
        const params = {
          userNo: uid,
          type: _type
        };
        const fileList = event.target.files;
        for (const key in fileList) {
          if (key === 'length') return;
          const files = fileList[ key ];

          if (fileList[ key ].size > me.limit[ me.currentType ].size) {
            me.$message.warning(me.limit[ me.currentType ].content);
            delete fileList[ key ];
            return false;
          }
          cosUpload(files, params, res => {
            me.$forceUpdate();
            const { tid, data } = res;
            const { loaded, speed, total, percent } = data;
            me.listProgress[ me.currentType ][ tid ] = {
              isUploading: true,
              tid: tid,
              loaded: (loaded / (1024 * 1024)).toFixed(2),
              speed: me.isNaN(speed) ? 0 : (speed / 1024).toFixed(1),
              total: (total / (1024 * 1024)).toFixed(2),
              percent: Math.floor(percent * 100),
              filename: files.name
            };
            me.swShow();
          }, (err, data, tid) => {
            if (err) {
              me.$message.error('文件上传失败');
              me.listProgress[ me.currentType ][ tid ].isUploading = false;
              return false;
            }
            const params = {
              userNo: Number(uid),
              content: [{
                filePath: data.Location,
                fileName: files.name,
                size: files.size
              }]
            };
            uploadRscApi(params).then(data => {
              if (data.success) {
                this.$message.success('文件上传成功！');
                this.getDraftsInfo();
                me.listProgress[ me.currentType ][ tid ].isUploading = false;
              } else {
                this.$message.error(data.errorMsg);
              }
            });
          });
        }
      }
    }
  };
</script>




